module.exports = __webpack_public_path__ + "img/mowers_shredders.238797ee.jpg";